import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19 3h-5.17a2 2 0 0 0-1.415.586l-9 9a2 2 0 0 0 0 2.828l5.172 5.172a2 2 0 0 0 2.828 0l9-9A2 2 0 0 0 21 10.172V5a2 2 0 0 0-2-2m-1.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
      clipRule: "evenodd"
    }
  )
);
var SvgTagsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TagsFilled_default = SvgTagsFilled;

export { TagsFilled_default as default };
